import React, { useState, useEffect } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import { FaEdit, FaRegEye } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { Modal } from 'flowbite-react';
import DataTable from 'react-data-table-component';

const CreateAdmin = () => {
  const [showForm, setShowForm] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [previewModal, setPreviewModal] = useState(false);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [adminData, setAdminData] = useState([]);
  const [formData, setFormData] = useState({
    id: '',
    UserName: '',
    Password: '',
    ConfirmPassword: '',
    email: '',
    contactNumber: '',
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const fetchAdminData = async () => {
    try {
      const response = await axios.get('https://backend.amarasinghemedicare.com/admin/admins');
      setAdminData(response.data);
    } catch (error) {
      console.error('Error fetching staff data:', error);
    }
  };

  useEffect(() => {
    fetchAdminData();
  }, []);

  const handleModalClose = () => {
    setOpenModal(false);
    setFormData({
      ConfirmPassword: '',
      contactNumber: '',
      email: '',
      Password: '',
      UserName: ''
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.Password !== formData.ConfirmPassword) {
      toast.error('Password should matched with confirm password!');
      return;
    }

    try {
      const response = await axios.post('https://backend.amarasinghemedicare.com/admin/register', formData);

      if (response.status === 200) {
        toast.success("Registered successfully!");
        setFormData({
          UserName: '',
          Password: '',
          email: '',
          contactNumber: '',
          ConfirmPassword: '',
        });
        fetchAdminData();
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        toast.error(error.response.data.error);
      } else {
        toast.error("Registration failed. Please try again.");
      }
    }
  };

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: '#202643',
        color: 'white',
        fontWeight: 'bold',
        fontSize: '13px',
      },
    },
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.patch('https://backend.amarasinghemedicare.com/admin/update', formData);

      if(response.status === 200){
        toast.success(response.data.message);
        fetchAdminData();
        setFormData({
          id: '',
          UserName: '',
          email: '',
          contactNumber: '',
        });
        setOpenModal(false);
      } else{
        toast.error("Something missing");
      }
    } catch (error) {
      toast.error("Something went wrong");
    }
  }

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(`https://backend.amarasinghemedicare.com/admin/delete/${id}`);

      if (response.status === 200) {
        toast.success(response.data.message);
        fetchAdminData();
      } else {
        toast.error('Something went wrong');
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Delete failed. Please try again.');
    }
  };

  const columns = [
    { name: 'Admin ID', selector: row => row.id, sortable: true },
    { name: 'Username', selector: row => row.UserName, sortable: true },
    { name: 'Email', selector: row => row.email, sortable: true },
    { name: 'Contact', selector: row => row.contactNumber, sortable: true },
    {
      name: 'Action',
      cell: row => (
        <div className="flex items-center justify-center space-x-3">
          <button onClick={() => { setSelectedAdmin(row); setPreviewModal(true); }} className="flex items-center justify-center font-semibold p-[6px] rounded-md shadow-md bg-blue text-white hover:bg-red-500">
            <FaRegEye />
          </button>
          <button
            onClick={() => {
              setIsEditMode(true);
              setFormData({
                id: row.id,
                UserName: row.UserName,
                email: row.email,
                contactNumber: row.contactNumber,
              });
              setOpenModal(true);
            }}
            className="flex items-center justify-center font-semibold p-[6px] rounded-md shadow-md bg-green text-white hover:bg-green-500">
            <FaEdit />
          </button>
          <button onClick={() => { handleDelete(row.id) }} className="flex items-center justify-center font-semibold p-[6px] rounded-md shadow-md bg-red text-white hover:bg-red-500">
            <MdDelete />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div>
      <Toaster />
      <div className="flex">
        <button
          className="text-[16px] text-white uppercase font-semibold text-left bg-[#97CE4F] p-2 rounded-lg transform transition-transform duration-300 hover:scale-105"
          onClick={() => setOpenModal(true)}
        >
          Register Admin
        </button>
      </div>

      <div className='h-fit p-[1px] mt-2 bg-[#202643]'>
        <DataTable
          columns={columns}
          data={adminData}
          fixedHeader
          fixedHeaderScrollHeight="80vh"
          className="data-table"
          customStyles={customStyles}
        />
      </div>

      <Modal size='md' show={openModal} onClose={handleModalClose} popup>
        <Modal.Header />
        <Modal.Body>
          <form
            onSubmit={isEditMode ? handleUpdate : handleSubmit}
            className="w-full space-y-4'"
          >
            <div>
              <h3 className="text-xl font-medium text-gray-900 mb-4">{isEditMode ? 'Update' : 'Register'} <span className='text-red'>New</span> Admin</h3>
              <div>
                <label htmlFor="" className="table-row text-[#261C53] text-[15px]">User Name:</label>
                <input
                  type="text"
                  id="UserName"
                  name="UserName"
                  value={formData.UserName}
                  onChange={handleChange}
                  required
                  className="w-full p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                />
              </div>

            </div>

            <div className="mt-4">
              <div>
                <label htmlFor="email" className="table-row text-[#261C53] text-[15px]">Email:</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                />
              </div>
            </div>

            <div className="mt-4">
              <div>
                <label htmlFor="contactNumber" className="table-row text-[#261C53] text-[15px]">Contact Number:</label>
                <input
                  type="text"
                  id="contactNumber"
                  name="contactNumber"
                  value={formData.contactNumber}
                  onChange={handleChange}
                  required
                  className="w-full p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                />
              </div>
            </div>

            {isEditMode ? (
              ""
            ) : (
              <div>
                <div className="mt-4">
                  <label htmlFor="Password" className="table-row text-[#261C53] text-[15px]">Password:</label>
                  <input
                    type="Password"
                    id="Password"
                    name="Password"
                    value={formData.Password}
                    onChange={handleChange}
                    required
                    className="w-full p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                  />
                </div>

                <div className="mt-4">
                  <label htmlFor="Password" className="table-row text-[#261C53] text-[15px]">Confirm Password:</label>
                  <input
                    type="password"
                    id="ConfirmPassword"
                    name="ConfirmPassword"
                    value={formData.ConfirmPassword}
                    onChange={handleChange}
                    required
                    className="w-full p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                  />
                </div>

              </div>
            )}
            <div className='flex justify-end items-center h-10 mt-5 gap-3'>
              <button
                type="submit"
                className="text-[16px] text-white uppercase font-semibold text-left bg-[#97CE4F] p-2 rounded-lg transform transition-transform duration-300 hover:scale-105"
              >
                {isEditMode ? 'Update' : 'Submit'}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      {previewModal && selectedAdmin && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-md w-[90%] md:w-[500px] max-h-[90vh] overflow-y-auto">
            <h2 className="text-xl font-semibold mb-4">Admin <span className='text-red'>Details</span></h2>
            <div className="">

              <table class="table-auto border border-gray-400 border-collapse w-full shadow-md mt-2">
                <tbody>
                  <tr class="border-b border-gray-300">
                    <td class="p-2 border border-gray-300 font-semibold">Admin ID</td>
                    <td class="p-2 border border-gray-300">{selectedAdmin.id}</td>
                  </tr>
                  <tr class="border-b border-gray-300">
                    <td class="p-2 border border-gray-300 font-semibold">Username</td>
                    <td class="p-2 border border-gray-300">{selectedAdmin.UserName}</td>
                  </tr>
                  <tr class="border-b border-gray-300">
                    <td class="p-2 border border-gray-300 font-semibold">Email</td>
                    <td class="p-2 border border-gray-300">{selectedAdmin.email}</td>
                  </tr>
                  <tr class="border-b border-gray-300">
                    <td class="p-2 border border-gray-300 font-semibold">Contact Number</td>
                    <td class="p-2 border border-gray-300">{selectedAdmin.contactNumber}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="mt-4 text-right">
              <button
                onClick={() => setPreviewModal(false)}
                className="bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600 bg-red"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default CreateAdmin;